module Shared.Admin.EditUser

open System
open Shared.Admin.ConfigTypes
open Illy.SafeStack

type DTO = 
    {
        Forename: string option
        Surname: string option
        ActiveDirectory: string option
        TelephoneNumber: string option
        Email: string option
        AdditionalText1: string option
    }

type InitData = 
    {
        Config: AdditionalFieldsConfig
        DTO: DTO
    }

module Validations = 
    open Illy.SafeStack.Validation
    open Illy.SafeStack.ROP
    open Illy.SafeStack.CompositionalValidation
    open Illy.SafeStack.SharedValidations
    open Shared.Validations.Email

    type EditUserValidations = 
        | ForenameValidations of StringValidations
        | SurnameValidations of StringValidations
        | ActiveDirectoryValidations of StringValidations
        | TelephoneNumberValidations of StringValidations
        | EmailValidations of EmailValidations
        | AdditionalText1Validations of StringValidations

    module EditUserValidations = 
        let toString = 
            function 
            | EmailValidations v -> EmailValidations.toString v
            | ForenameValidations v 
            | SurnameValidations v 
            | ActiveDirectoryValidations v 
            | TelephoneNumberValidations v 
            | AdditionalText1Validations v -> v.toString()

    let validateDTO (dto: DTO) = 
        validate {
            return! (validateString 250 true >-> EditUserValidations.ForenameValidations) dto.Forename
            return! (validateString 250 true >-> EditUserValidations.SurnameValidations) dto.Surname
            return! (validateString 250 false >-> EditUserValidations.ActiveDirectoryValidations) dto.ActiveDirectory
            return! (validateString 50 false >-> EditUserValidations.TelephoneNumberValidations) dto.TelephoneNumber
            return! (validateEmail >-> EditUserValidations.EmailValidations) dto.Email
            return! (validateString 50 false >-> EditUserValidations.AdditionalText1Validations) dto.AdditionalText1
        }

type FailureReason = 
    | NothingToDo
    | FailedValidations of Validation.ValidationResult<Validations.EditUserValidations, Validation.NoWarning>
    